import React from 'react';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import { View, Text } from 'react-native';
import { ConfirmTouchableArea } from 'root/globals/Elements';
import { Link } from "react-router-dom";
import { Menu as ContextMenu, MenuItem } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'root/libs/exaforte/react/lodash';

import {
    faEllipsisV,
} from '@fortawesome/pro-regular-svg-icons';

import defaults from 'root/globals/Defaults.less';
import menu from './Menu.less';

const styles = {...defaults, ...menu};

export default class Menu extends React.Component {
    constructor(props) {
        super(props);
        
        this._toggle        = this._toggle.bind(this);
        this.state          = {open: false};
        this.trigger_ref    = React.createRef();
    }
    
    _toggle() {
        this.setState(state => ({open: !state.open}));
    }
    
    // Deze functie zorgt ervoor dat het menu weer verdwijnt wanneer je een optie uit het menu aanklikt.
    _clickItem(index) {
        if(this.props.items[index].onPress)
            this.props.items[index].onPress(this.props.items[index].onPressParams);
        
        this.setState({open: false});
    }
    
    render (){
        return (
            <>
                <TouchableArea aria-controls="simple-menu" aria-haspopup="true" onPress={this._toggle} forwardedRef={this.trigger_ref}>
                    {this.props.children || (
                        <View className={[styles['button'], styles['f-3'], 'px-2']}>
                            <FontAwesomeIcon icon={faEllipsisV} />
                        </View>
                    )}
                </TouchableArea>
                <ContextMenu open={this.state.open} anchorEl={this.trigger_ref.current} onClose={this._toggle}>
                    {_.map(this.props.items, (item, index) => (
                        <ConfirmTouchableArea {...(!item.disabled ? { onPress: () => this._clickItem(index), confirmMessage: item.confirmMessage } : {} )} key={'menu-item-' + this.props.id + '-' + index}>
                            <MenuItem className={[styles['menuItem'], 'py-2 px-3 d-flex flex-row align-items-center', styles['background-color-white'], styles['text-color-black'], styles['text-light'], ...(item.disabled ? [styles['disabled']] : [])].join(' ')}>
                                {item.icon && (
                                    <View className={[styles['menuItemIcon']]}>
                                        <FontAwesomeIcon icon={item.icon} className={'mr-2'} />
                                    </View>
                                )}
                                <Text className={[styles['f-1-5']]}>{item.title}</Text> 
                            </MenuItem>
                        </ConfirmTouchableArea>
                    ))}
                </ContextMenu>
            </>
        );
    }
}